import { Check, ClipboardList, Cog, Compass, Monitor, Palette, ShieldAlert, Users } from 'lucide-react';
import { LAUNCH_WHAT_WE_BUILD } from '@/data/launch';
import { Reveal } from '../Reveal';

const ACCENT = '#4225C4';
const ACCENT_SOFT = '#E4E0FA';

const BLOCK_ICONS = {
  compass: Compass,
  'clipboard-list': ClipboardList,
  palette: Palette,
  monitor: Monitor,
  cog: Cog,
  users: Users,
};

export const WhatWeBuild = () => (
  <section aria-labelledby="what-we-build-heading" data-testid="what-we-build-section" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
        <Reveal className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <p className="flex items-center gap-3">
              <span className="font-mono text-xs font-medium tracking-widest" style={{ color: ACCENT }}>02</span>
              <span className="text-xs font-bold uppercase tracking-[0.2em]" style={{ color: ACCENT }}>
                {LAUNCH_WHAT_WE_BUILD.eyebrow}
              </span>
            </p>
            <h2 id="what-we-build-heading" className="mt-4 text-balance text-3xl font-extrabold tracking-tight text-navy-900 sm:text-4xl">
              {LAUNCH_WHAT_WE_BUILD.heading}
            </h2>
            <p className="mt-5 max-w-md text-base leading-relaxed text-slate-600 sm:text-lg">
              {LAUNCH_WHAT_WE_BUILD.intro}
            </p>
            <div className="mt-8 flex items-start gap-3 rounded-xl border border-slate-200 bg-mist p-5" data-testid="regulated-advice-note">
              <ShieldAlert className="mt-0.5 h-5 w-5 shrink-0" style={{ color: ACCENT }} aria-hidden="true" />
              <p className="text-sm leading-relaxed text-slate-600">{LAUNCH_WHAT_WE_BUILD.disclaimer}</p>
            </div>
          </div>
        </Reveal>

        <div className="space-y-5 lg:col-span-8">
          {LAUNCH_WHAT_WE_BUILD.blocks.map((block, i) => {
            const Icon = BLOCK_ICONS[block.icon];
            return (
              <Reveal key={block.id} delay={i * 0.05}>
                <div
                  data-testid={`build-block-${block.id}`}
                  className="grid gap-5 rounded-2xl border border-slate-200 bg-white p-7 transition-shadow duration-300 hover:shadow-card sm:grid-cols-[220px_1fr] sm:gap-8 sm:p-8"
                >
                  <div className="flex items-center gap-4">
                    <span
                      className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg"
                      style={{ backgroundColor: ACCENT_SOFT, color: ACCENT }}
                    >
                      <Icon className="h-5 w-5" aria-hidden="true" />
                    </span>
                    <h3 className="text-lg font-extrabold leading-snug tracking-tight text-navy-900">{block.title}</h3>
                  </div>
                  <ul className="flex flex-wrap gap-x-6 gap-y-2.5">
                    {block.items.map((item) => (
                      <li key={item} className="flex items-center gap-2 text-sm font-medium text-navy-800">
                        <Check className="h-3.5 w-3.5 shrink-0" style={{ color: ACCENT }} aria-hidden="true" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);
